import React from 'react'

import Radio, { RadioProps } from '@material-ui/core/Radio'
import { RadioGroup, FormControlLabel, withStyles } from '@material-ui/core'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'

import * as config from 'styles/tailwind.config'

interface IOption {
  value: string | number
  label: string
}

interface IProps {
  value: string | number
  options: IOption[]
  label?: string
  required?: boolean
  error?: string
  underline?: boolean
  onChange?: (value: string) => void
}

const StyledRadio = withStyles({
  root: {
    color: config.theme.colors.black,
  },
  checked: {},
})((props: RadioProps) => (
  <Radio
    color="default"
    {...props}
    icon={<RadioButtonUncheckedIcon style={{ width: 12, height: 12 }} />}
    checkedIcon={<RadioButtonCheckedIcon style={{ width: 12, height: 12 }} />}
  />
))

const CustomRadio: React.FC<IProps> = props => {
  const { value, options, onChange, label, required, underline, error } = props

  const handleChange = (e: React.ChangeEvent<unknown>) => {
    const value = (e.target as HTMLInputElement).value
    if (onChange) onChange(value)
  }

  return (
    <div className="w-full">
      {label && underline ? (
        <label
          className={`font-500 text-10 tracking-1.5 uppercase ${error ? 'text-red' : 'text-black'}`}
        >
          {label} {required && '*'}
        </label>
      ) : (
        label && (
          <label className={`label ${error && 'text-red'}`}>
            {label} {required && '*'}
          </label>
        )
      )}
      <div
        className="flex"
        style={{
          height: underline ? 56 : 56,
          alignItems: 'center',
        }}
      >
        <RadioGroup
          name={label}
          value={String(value)}
          onChange={handleChange}
          style={{
            width: '100%',
            flexDirection: 'row',
          }}
        >
          {options.map(option => {
            if (underline) {
              return (
                <div
                  key={option.value}
                  className={`flex-1 mr-30 pb-5 last-child:mr-0 border-b-1 ${
                    value === option.value ? 'border-black' : 'border-gray-200'
                  }`}
                >
                  <FormControlLabel
                    value={option.value}
                    control={<StyledRadio />}
                    label={
                      <span className="font-400 tracking-0.1 text-black text-13">
                        {option.label}
                      </span>
                    }
                    labelPlacement="end"
                  />
                </div>
              )
            }

            return (
              <div key={option.value} className={`mr-30`}>
                <FormControlLabel
                  value={option.value}
                  control={<StyledRadio />}
                  label={
                    <span className="font-400 tracking-0.1 text-black text-13">{option.label}</span>
                  }
                  labelPlacement="end"
                />
              </div>
            )
          })}
        </RadioGroup>
      </div>
    </div>
  )
}

export default CustomRadio
